import Vue from 'vue';

//import Colcade from 'colcade';
Vue.component('events-columns', {
    data() {
        return {
        }
    },

    mounted() {

        if (document.querySelector('.upcoming-events-column--grid') !== null) {
            Vue.nextTick(this.initColumns);
        }
    },

    methods: {
        async initColumns() {
            const Colcade = await import(/* webpackChunkName: "vendors~colcade" */ 'colcade')
                .then(module => {
                    return module.default
                }) // using the default export
                .catch(() => {
                    console.log('Handle error!');
                });

            this.colcade = new Colcade('.upcoming-events-column--grid', {
                columns: '.grid-col',
                items: '.upcoming-event'
            });
        }
    }
});
